export default __webpack_public_path__ + "static/media/AM-opinion-Tech-Lend-080919 sg.3a1cfee2.pdf";